import React from "react";
import { ensureUnauthPageBuilderInit } from "utils/hooks/unauth";
import Layout from "components/Layout";
import {
  fetchAppCheckout,
  fetchAppPagesTemplatesIndex,
  fetchAppBuilder,
  fetchAppEntities,
  fetchAppPagesTemplate
} from "actions/app";
import { createShortLink } from "actions/shortLink";
import { fetchMockUserDetails, fetchUserDetails } from "actions/auth";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import EditorLoader from "components/FormerEditor/EditorLoader";
import PageTypePickerContainer from "components/PageTypePickerContainer";
import { PagePickerContextProvider } from "utils/context/builder/page";

/**
 * Note:
 * - Wrapper around components/ManifestLayout
 * - src/components/scratch/Page/index.jsx
 * - We should fetch "template" pages from the BE
 * - Wrapper component has state like link builder where you select a type of page template to start with
 * - Type selection then triggers a refetch of mock data and a rendering of the page
 * - The back icon then allows for changing template
 *
 * Authed components
 * - ManifestLayout
 * - FormerEditor
 */
const BuilderApplications = ({ actions }) => {
  const { loading } = ensureUnauthPageBuilderInit({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices,
    fetchMerchantAccountCouponsPromotionCodes:
      actions.fetchMerchantAccountCouponsPromotionCodes,
    fetchMerchantAccountTaxRates: actions.fetchMerchantAccountTaxRates,
    fetchMerchantAccountShippingRates:
      actions.fetchMerchantAccountShippingRates,
    fetchAppCheckout: actions.fetchAppCheckout,
    fetchAppPageTemplatesList: actions.fetchAppPageTemplatesList,
    fetchAppBuilder: actions.fetchAppBuilder,
    fetchUserDetails: actions.fetchUserDetails,
    fetchAppPagesTemplatesIndex: actions.fetchAppPagesTemplatesIndex,
    fetchAppPagesTemplate: actions.fetchAppPagesTemplate,
    fetchAppEntities: actions.fetchAppEntities,
    fetchMockUserDetails: actions.fetchMockUserDetails
  });

  return (
    <Layout>
      {() =>
        loading ? (
          <EditorLoader />
        ) : (
          <PagePickerContextProvider>
            <PageTypePickerContainer />
          </PagePickerContextProvider>
        )
      }
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createShortLink,
      fetchAppCheckout,
      fetchAppPagesTemplatesIndex,
      fetchAppPagesTemplate,
      fetchAppEntities,
      fetchAppBuilder,
      fetchUserDetails,
      fetchMockUserDetails,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(BuilderApplications);
